module.exports = __webpack_public_path__ + "img/nb-logo.da5534f9.svg";